var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBackgroundCircle = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 480,
  height: 480,
  fill: "none",
  viewBox: "0 0 480 480",
  ref: ref
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "b",
  width: 480,
  height: 480,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#a)",
  d: "M0 0h480v480H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  mask: "url(#b)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 240,
  cy: 240,
  r: 47.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 240,
  cy: 240,
  r: 79.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 240,
  cy: 240,
  r: 111.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 240,
  cy: 240,
  r: 143.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 240,
  cy: 240,
  r: 143.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 240,
  cy: 240,
  r: 175.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 240,
  cy: 240,
  r: 207.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 240,
  cy: 240,
  r: 239.5
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "a",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(90 0 240)scale(240)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBackgroundCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/background-circle.be38a36e4dc7cdf7442984a2aad3c6ad.svg";